interface EngineWarningIconProps {
  engineChecks?: any;
}

export function EngineWarningIcon({ engineChecks }: EngineWarningIconProps) {
  // Don't render if no engine checks or no errors
  if (!engineChecks) return null;

  const hasErrorCells = engineChecks.spreadjs?.errorCells?.length > 0;
  const hasErrors = engineChecks.spreadjs?.errors?.length > 0;

  if (!hasErrorCells && !hasErrors) return null;

  const errorCount = engineChecks.spreadjs?.errorCells?.length || 0;
  const errorMessages = engineChecks.spreadjs?.errors || [];

  const tooltipText = `${errorCount} error cell${errorCount !== 1 ? 's' : ''}${
    errorMessages.length > 0 ? ': ' + errorMessages.join(', ') : ''
  }`;

  return (
    <div
      title={tooltipText}
      className="flex items-center justify-center px-2 py-1.5 bg-[rgba(251,146,60,0.15)] rounded-md cursor-help"
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="text-[#ea580c]"
      >
        <path
          d="M8 1L1 15H15L8 1Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M8 6V9"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <circle cx="8" cy="12" r="0.5" fill="currentColor" />
      </svg>
    </div>
  );
}
